import React, {useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {FaCopy, FaLink} from "react-icons/fa";
import AreaChartPreview from "./render";

export const AreaChart = () => {
    const [copied, setCopied] = useState(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const [environment, setEnvironment] = useState(queryParams.get("environment") || "DEV");
    const [colorBackground, setColorBackground] = useState(queryParams.get("colorBackground") || "FFFFFF");
    const [series, setSeries] = useState(queryParams.get("series") || "January,February,March,April,May");
    const [values, setValues] = useState(queryParams.get("values") || "300,400,350,500,420");
    const [color, setColor] = useState(queryParams.get("color") || "0b1b88");
    const [colorSecondary, setColorSecondary] = useState(queryParams.get("colorSecondary") || "808de7");
    const [height, setHeight] = useState(queryParams.get("height") || '200');
    const [seriesName, setSeriesName] = useState(queryParams.get("seriesName") || "Evolution");
    const [fontFamily, setFontFamily] = useState(queryParams.get("fontFamily") || "Arial, sans-serif");


    const handleCopy = () => {
        navigator.clipboard.writeText(linkToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const linkToCopy =
        process.env.REACT_APP_FRONT_URL + "/areachart?na=1"
        + "&environment=PROD"
        + "&fontFamily=" + fontFamily
        + "&color=" + color
        + "&colorSecondary=" + colorSecondary
        + "&height=" + height
        + "&series=" + series
        + "&values=" + values
        + "&seriesName=" + seriesName
        + "&colorBackground=" + colorBackground;



    return (
        <div className="flex flex-col items-center justify-center" style={{width:'100%',backgroundColor:colorBackground}}>
            {environment=== "DEV" && (
                <>
                    <h1 style={{fontSize: 40, fontWeight: 'bold'}}>
                        Area Chart
                    </h1>
                    <br/><br/>
                    <h3 className="text-lg font-semibold mb-3">QUERY PARAMETERS</h3>
                    <br/>

                    <h3 className="text-md font-semibold mb-3 mt-10">Chart configuration</h3>
                    <div className="flex flex-wrap items-start justify-start gap-4 w-full">

                        <div
                            className="h-auto rounded overflow-hidden  bg-white"
                            style={{width: 400}}
                        >
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">fontFamily</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Tipografia
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setFontFamily(e.target.value)}
                                        value={fontFamily}
                                    >
                                        <option value="Arial, sans-serif">
                                            Arial, sans-serif
                                        </option>
                                        <option value="Courier New, monospace">
                                            Courier New, monospace
                                        </option>
                                        <option value="Helvetica, sans-serif">
                                            Helvetica, sans-serif
                                        </option>
                                        <option value="Verdana, sans-serif">
                                            Verdana, sans-serif
                                        </option>
                                        <option value="Tahoma, sans-serif">
                                            Tahoma, sans-serif
                                        </option>
                                        <option value="Trebuchet MS, sans-serif">
                                            Trebuchet MS, sans-serif
                                        </option>
                                        <option value="Open Sans, sans-serif">
                                            Open Sans, sans-serif
                                        </option>
                                        <option value="Roboto, sans-serif">
                                            Roboto, sans-serif
                                        </option>
                                    </select>
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">color</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Color Primario
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setColor(e.target.value)}
                                        value={color}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">colorSecondary</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Color Secundario
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setColorSecondary(e.target.value)}
                                        value={colorSecondary}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">height</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Alto del Gráfico
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setHeight(e.target.value)}
                                        value={height}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">series</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Categorias
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSeries(e.target.value)}
                                        value={series}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">values</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Valores
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setValues(e.target.value)}
                                        value={values}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">colorBackground</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Color de fondo
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setColorBackground(e.target.value)}
                                        value={colorBackground}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">seriesName</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Nombre de la serie
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSeriesName(e.target.value)}
                                        value={seriesName}
                                    />
                                </p>
                            </div>
                        </div>


                    </div>


                    <h3 className="text-lg font-semibold mb-3">PREVIEW</h3>

                    <br/><br/>
                </>)}
            <div style={{width: '100%', backgroundColor: colorBackground}}>
                <AreaChartPreview
                    color={color}
                    height={height}
                    colorBackground={colorBackground}
                    colorSecondary={colorSecondary}
                    series={series}
                    values={values}
                    seriesName={seriesName}
                    fontFamily={fontFamily}
                />
            </div>

            {environment === "DEV" && (
                <div>
                    <br/><br/>
                    <div className="flex items-center mb-5">
                        <button
                            onClick={handleCopy}
                            className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600"
                        >
                        <FaCopy className="mr-2"/>
                            {copied ? "Copied!" : "Copy Link"}
                        </button>

                        <Link to={"/"}>
                            <button
                                className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600">
                                <FaLink className="mr-2"/>
                                Go to Home
                            </button>
                        </Link>
                    </div>

                </div>
            )}
        </div>

    );
};
